/* eslint-disable react/prefer-es6-class, react/sort-comp */
import React from 'react';
import { ChoicesSessionSize, ChoicesGoalSource } from 'es6/components/apps/choices';
import { t } from 'es6/services/localization';
import StudyAllRibbon from 'es6/components/apps/study-all-ribbon';
import { TranscodedImageSizes, TranscodedImagePlaceholders, TranscodedImage } from 'es6/components/common/transcoded-image';
import WelcomeSentenceTrainerMixin from 'es6/components/apps/mixins/welcome-sentence-trainer';

const COURSE_IMAGE_COUNT = 6;

export default React.createClass({
  displayName: 'WelcomeSentenceTrainerStudyAllScreen',

  mixins: [WelcomeSentenceTrainerMixin],

  propTypes: {
    onGoalSourceChange: React.PropTypes.func.isRequired,
    onSessionSizeChange: React.PropTypes.func.isRequired,
    sessionConfig: React.PropTypes.object.isRequired,
    sessionData: React.PropTypes.object.isRequired,
    sessionSizes: React.PropTypes.array,
  },

  getDefaultProps() {
    return {
      sessionSizes: [5, 10, 20],
    };
  },

  render() {
    return (
      <div className="screen screen-welcome-sentence-trainer screen-welcome-sentence-trainer-study-all">
        <StudyAllRibbon />

        <div className="screen-content">
          <span className="loading-spinner"></span>

          <h2 className="title">{t('sentence-trainer-study-all')}</h2>

          <div className="course-images">
            {this._renderCourseImages()}
          </div>

          <div className="next-session">
            <div className="session-config">
              <div className="session-config-setting">
                <label className="choice-label">
                  {t('sentence-trainer.session-size')}
                </label>

                <ChoicesSessionSize sizes={this.props.sessionSizes} sessionConfig={this.props.sessionConfig} onChange={this.props.onSessionSizeChange} className="choice-set-expanded" />
              </div>

              <div className="session-config-setting">
                <label className="choice-label">
                  {t('goal-source')}
                </label>

                <ChoicesGoalSource sessionConfig={this.props.sessionConfig} onChange={this.props.onGoalSourceChange} className="choice-set-expanded" />
              </div>
            </div>

            {this._renderSessionDetails()}
          </div>
        </div>

        {this._renderNavigation()}
      </div>
    );
  },

  _renderCourseImages() {
    // Get the goals that are in the session.
    const sessionData = this.props.sessionData;
    const goalIds = sessionData.studySession
      .map(studyNode => studyNode.goalId)
      .filter((v, i, s) => s.indexOf(v) === i);
    const goals = sessionData.goals.filter(g => goalIds.indexOf(g.id) !== -1);

    // Build the components.
    const components = [];
    for (let i = 0; i < COURSE_IMAGE_COUNT; i++) {
      const goal = goals[i];
      const src = goal ? goal.icon : null;

      components.push(
        (<TranscodedImage key={i} size={TranscodedImageSizes.MEDIUM} src={src} placeholder={TranscodedImagePlaceholders.APP} />)
      );
    }

    return components;
  },
});
